<!-- eslint-disable max-len -->
<template>
  <v-dialog v-model="isVisible" max-width="900">
    <v-card>
      <v-card-title class="input-text-size">{{ header }}</v-card-title>
      <v-card-text class="input-text-size">
 <v-row dense><v-col cols="5" >
                   <ClarionDateControl class="input-text-size"
                         :isRequired="false" :isIsoDate="false" :isToggle="false"
                         label="Penalty Date" v-model="settings.penaltyDate"/>
                </v-col></v-row>
        <v-container>

          <v-row dense>
            <v-col cols="6">
              <h4>Fields to include:</h4>
            </v-col>
            <v-col cols="6">
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="3">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="TaxId"
                v-model="settings.taxId"
              ></v-checkbox>
            </v-col>
            <v-col cols="3">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Parcel ID"
                v-model="settings.parcelId"
              ></v-checkbox>
            </v-col>
            <v-col cols="6">
              <div class="print-order-border mt-n12">
                <h4 class="text-center mb-2">Print Order:</h4>
                <v-radio-group
                  row
                  dense
                  v-model="settings.printOrder"
                  hide-details
                >
                  <v-radio dense
                    class="input-text-size"
                    label="Owner Name"
                    value="orderOwnerName"
                  ></v-radio>
                  <v-radio dense
                    class="input-text-size"
                    label="Tax ID"
                    value="orderTaxId"
                  ></v-radio>
                  <v-radio dense
                    class="input-text-size"
                    label="Parcel ID"
                    value="orderPID"
                  ></v-radio>
                </v-radio-group>
              </div>
            </v-col>
            <v-col cols="3">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Owner name"
                v-model="settings.ownerName"
              ></v-checkbox>
            </v-col>
            <v-col cols="3">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Situs Address"
                v-model="settings.situsAddress"
              ></v-checkbox>
            </v-col>
            <v-col cols="3">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Include List of Delinquents"
                v-model="settings.includeDelinquents"
                @change="updateIncludeDelinquents()"
              ></v-checkbox>
            </v-col>
             <v-col cols="3">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Name 2"
                v-model="settings.includeNameTwo"
              ></v-checkbox>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="6">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Legal Description"
                v-model="legalDescriptionChecked"
                @change="updateDescriptionType('legalDescription', $event)"
              ></v-checkbox>
            </v-col>
            <v-col cols="3">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Addition Lot And Block"
                v-model="additionLotBlockChecked"
                @change="updateDescriptionType('additionLotAndBlock', $event)"
              ></v-checkbox>
            </v-col>
             <v-col cols="3">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Care Of"
                v-model="settings.includeCareOf"
              ></v-checkbox>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="6">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Tax, Penalty & Fees Due"
                v-model="settings.taxPenaltyFeesDue"
              ></v-checkbox>
            </v-col>
            <v-col cols="4">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Include Headers"
                v-model="settings.includeHeaders"
                :disabled="disableIncludeHeaders"
              ></v-checkbox>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="6">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Total Due"
                v-model="settings.totalDue"
              ></v-checkbox>
            </v-col>
            <v-col cols="6">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Separate Amounts By Year"
                v-model="separateAmountsChecked"
                @change="updateAmountDisplayType('separateAmounts', $event)"
              ></v-checkbox>
            </v-col>
          </v-row>
          <div>
            <h4>Preview:</h4>
            <p class="preview-text">{{ previewText }}</p>
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions class="input-text-size">
        <v-btn color="primary" small @click="generatePublication">
          Generate
        </v-btn>
        <v-btn small @click="closeDialog">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { toShortDate } from '../../../../../../util/shared/tmc-global';
import { amountFormat } from '../../../../../../util/shared/vue-global';
import ClarionDateControl from '../../../../../common/ClarionDateControl.vue';

export default {
  name: 'JuneResalePublicationDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    header: {
      type: String,
      default: 'Publication TXT Settings',
    },
    taxInquiryData: {
      type: Object,
      default: () => {},
    },
    penaltyDate: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // Completely isolated local state - no Vuex dependency
      settings: {
        taxId: true,
        parcelId: false,
        ownerName: true,
        situsAddress: false,
        includeNameTwo: false,
        includeCareOf: false,
        includeDelinquents: false,
        descriptionType: 'legalDescription',
        taxPenaltyFeesDue: false,
        includeHeaders: false,
        totalDue: false,
        amountDisplayType: 'totalDueOnly',
        printOrder: 'orderOwnerName',
        penaltyDate: toShortDate(),
      },
      disableIncludeHeaders: true,
    };
  },
  computed: {
    ...mapState({
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
    }),
    isVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    legalDescriptionChecked: {
      get() {
        return this.settings.descriptionType === 'legalDescription';
      },
      set(val) {
        this.updateDescriptionType('legalDescription', val);
      },
    },
    additionLotBlockChecked: {
      get() {
        return this.settings.descriptionType === 'additionLotAndBlock';
      },
      set(val) {
        this.updateDescriptionType('additionLotAndBlock', val);
      },
    },
    totalDueOnlyChecked: {
      get() {
        return this.settings.amountDisplayType === 'totalDueOnly';
      },
      set(val) {
        this.updateAmountDisplayType('totalDueOnly', val);
      },
    },
    separateAmountsChecked: {
      get() {
        return this.settings.amountDisplayType === 'separateAmounts';
      },
      set(val) {
        this.updateAmountDisplayType('separateAmounts', val);
      },
    },
    previewText() {
      // Get sample data for preview
      let sampleData = {};
      if (this.taxInquiryData && Object.keys(this.taxInquiryData).length > 0) {
        sampleData = this.taxInquiryData;
      }

      if (!sampleData || Object.keys(sampleData).length === 0) {
        return 'No data available for preview';
      }

      const previewLines = [];

      // Tax ID and Parcel ID
      if (this.settings.taxId && sampleData.mainTaxId) {
        previewLines.push(`Tax Year: ${sampleData.mainTaxYear} Tax ID: ${sampleData.mainTaxId}`);
      }
      if (this.settings.parcelId && sampleData.mainPropertyOrParcelId) {
        previewLines.push(`Parcel ID: ${sampleData.mainPropertyOrParcelId}`);
      }
      // Owner name
      const ownerNameDetails = [];
      if (this.settings.ownerName && sampleData.name1) {
        ownerNameDetails.push(sampleData.name1);
      }
      if (this.settings.includeNameTwo && sampleData.name2) {
        ownerNameDetails.push(sampleData.name2);
      }
      if (this.settings.includeCareOf && (sampleData.inCareOf1 || sampleData.inCareOf2)) {
        ownerNameDetails.push(sampleData.inCareOf1);
        ownerNameDetails.push(sampleData.inCareOf2);
      }
      const ownerConcatenatedName = ownerNameDetails.join(' ');
      if (ownerConcatenatedName) previewLines.push(ownerConcatenatedName);
      if (this.settings.situsAddress && sampleData.mainSitusAddress) {
        previewLines.push(sampleData.mainSitusAddress);
      }
      // Description
      const descriptionFields = [];
      if (this.settings.descriptionType === 'legalDescription' && sampleData.mainLegalDesc) {
        descriptionFields.push(`Legal Description: ${sampleData.mainLegalDesc}`);
      } else if (this.settings.descriptionType === 'additionLotAndBlock') {
        const addition = sampleData.addition || '';
        const lots = sampleData.lots || '';
        const block = sampleData.block || '';
        if (addition || lots || block) {
          descriptionFields.push(`Addition Lot & Block: ${addition} ${lots} ${block}`.trim());
        }
      }
      if (descriptionFields.length > 0) {
        previewLines.push(descriptionFields.join(' | '));
      }
      // Add delinquent records if includeDelinquents is selected
      if (this.settings.includeDelinquents) {
        const delinquentRecords = (this.taxInquiryData || {}).taxDetails || [];

        // First try to get delinquent records from the dedicated delinquent data
        if (delinquentRecords.length > 0) {
          const YEAR_LEN = 15;
          const TAX_LEN = 8;
          const PENALTY_LEN = 15;
          const FEES_LEN = 11;
          const TOTAL_LEN = 11;

          if (this.settings.taxPenaltyFeesDue && this.settings.includeHeaders) {
            previewLines.push('Year'.padEnd(YEAR_LEN)
              + 'Tax'.padStart(TAX_LEN)
              + 'Penalty'.padStart(PENALTY_LEN)
              + 'Fees'.padStart(FEES_LEN)
              + 'Total'.padStart(TOTAL_LEN));
          }

          delinquentRecords.forEach((record) => {
            const yearVal = `${record.taxYear}${(record.taxType || '').toUpperCase()}`;
            const taxVal = amountFormat(record.totalTaxDue);
            const penaltyVal = amountFormat(record.currentPenalty);
            const feesVal = amountFormat(record.totalFeesDue);
            const totalVal = amountFormat(record.totalDue);
            if (this.settings.taxPenaltyFeesDue) {
              previewLines.push(
                yearVal.padEnd(YEAR_LEN)
              + taxVal.padStart(TAX_LEN)
              + penaltyVal.padStart(PENALTY_LEN)
              + feesVal.padStart(FEES_LEN)
              + totalVal.padStart(TOTAL_LEN),
              );
            }
            if (this.settings.totalDue && !this.settings.taxPenaltyFeesDue) {
              previewLines.push(`${yearVal} - $${totalVal}`);
            }
          });
        }
      }
      if (this.settings.taxPenaltyFeesDue) {
        previewLines.push(`Tax: $${amountFormat(sampleData.mainTotalTaxDue)} Penalty: $${amountFormat(sampleData.mainTotalPenalty)} Fees: $${amountFormat(sampleData.mainTotalFeesDue)}`.trim());
      }
      if (this.settings.totalDue) {
        previewLines.push(`Total Due: $${amountFormat(sampleData.mainTotalDue || 0)}`);
      }
      if (this.settings.amountDisplayType === 'separateAmounts') {
        const separateAmounts = [];
        if (sampleData.mainTotalTaxDue) {
          separateAmounts.push(`Tax: $${amountFormat(sampleData.mainTotalTaxDue)}`);
        }
        if (sampleData.mainTotalFeesDue) {
          separateAmounts.push(`Fees: $${amountFormat(sampleData.mainTotalFeesDue)}`);
        }
        if (separateAmounts.length > 0) {
          previewLines.push(`Separate Amounts: ${separateAmounts.join(', ')}`);
        }
      }

      return previewLines.length > 0 ? previewLines.join('\n') : 'Select fields to see preview';
    },
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        // Reset penalty date to today's date when dialog opens
        this.resetPenaltyDate();
      }
    },
  },
  components: {
    ClarionDateControl,
  },
  methods: {
    updateIncludeDelinquents() {
      if (!this.settings.includeDelinquents) {
        this.settings.includeHeaders = false;
        this.disableIncludeHeaders = true;
      } else {
        this.disableIncludeHeaders = false;
      }
    },
    updateDescriptionType(type, isChecked) {
      if (isChecked) {
        this.settings.descriptionType = type;
      } else {
        this.settings.descriptionType = null;
      }
    },
    updateAmountDisplayType(type, isChecked) {
      if (isChecked) {
        this.settings.amountDisplayType = type;
      } else {
        this.settings.amountDisplayType = null;
      }
    },
    generatePublication() {
      // Emit the settings to parent component
      this.$emit('generate', this.settings);
      this.closeDialog();
    },
    closeDialog() {
      this.isVisible = false;
    },
    resetPenaltyDate() {
      // Reset penalty date to today's date when dialog opens
      this.settings.penaltyDate = this.penaltyDate || toShortDate();
    },
  },
};
</script>

<style scoped>
.print-order-border {
  border: 1px solid #ccc;
  border-radius: 12px;
  padding: 8px;
  margin: 4px 0;
}

.preview-text {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px;
  font-family: monospace;
  font-size: 12px;
  max-height: 150px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
